import { Label, Spacer } from '@vinted/web-ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const LinksGroup = _ref => {
  let {
    title,
    children
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Label, {
      text: title,
      type: Label.Type.Stacked,
      styling: Label.Styling.Narrow
    }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx("div", {
      children: children
    })]
  });
};

export default LinksGroup;